// extracted by mini-css-extract-plugin
export default {"custom-tooltip":"custom-tooltip_custom-tooltip__DeEkU","center":"custom-tooltip_center__y9B0C","left":"custom-tooltip_left__sdRt2","right":"custom-tooltip_right__3tHmR"};